define(function(require, exports, module) {
    var $, inherit, Emitter, UPDATE_TIMEOUT;

    $ = require('jquery');
    inherit = require('inherit');
    Emitter = require('Emitter');

    UPDATE_TIMEOUT = 10 * 60 * 1000;

    function prepareDomainFolders(folders) {
        folders.forEach(function(folder) {
            folder.id = folder.home;
            folder.text = folder.name || folder.home.split('/').pop();
            folder.href = '/home' + folder.home;
            folder.icon = 'ico_folder_user';

            return folder;
        });

        return folders;
    }

    function DomainFolders(options) {
        options || (options = {});

        this._data = [];
        this._loadDeferred = null;
        this._api = options.api;

        this._enabled = options.enabled;

        this._initializeDataSequence = this._initializeDataSequence.bind(this);

        if (this.isEnabled()) {
            this._initializeDataSequence();
        }
    }

    DomainFolders.prototype = DomainFolders.fn = {
        _requestUpdate: function() {
            clearTimeout(this._updateTimeout);

            this._updateTimeout = setTimeout(this._initializeDataSequence, UPDATE_TIMEOUT);
        },

        _initializeDataSequence: function() {
            this._loadData();
            this._requestUpdate();
        },

        load: function() {
            var domainFolders = this.getFolders();
            var d = new $.Deferred();

            if (domainFolders) {
                if (domainFolders.length) {
                    d.resolve(domainFolders);
                } else {
                    d = this._loadData();
                }
            } else {
                d.resolve([]);
            }

            return d.promise();
        },

        _loadData: function() {
            var deferred;

            if (this._loadDeferred && this._loadDeferred.state() === 'pending') {
                return this._loadDeferred;
            }

            this._loadDeferred = new $.Deferred();
            deferred = this._loadDeferred;

            if (this.isEnabled()) {
                this._api.domain
                    .folders()
                    .done(
                        function(folders) {
                            this._data = prepareDomainFolders(folders);
                            this.emit('update', this._data);
                            this._loadDeferred.resolve(this._data);
                            this._loadDeferred = null;
                        }.bind(this)
                    )

                    .fail(
                        function() {
                            this._loadDeferred.reject([]);
                            this._loadDeferred = null;
                        }.bind(this)
                    );
            } else {
                this._loadDeferred.resolve([]);
                this._loadDeferred = null;
            }

            return deferred;
        },

        isEnabled: function() {
            return this._enabled;
        },

        getFolders: function() {
            return this.isEnabled() ? this._data : void 0;
        },

        destroy: function() {
            clearTimeout(this._updateTimeout);

            this._data = null;
        },
    };

    inherit.apply(DomainFolders);

    Emitter.apply(DomainFolders.fn);

    module.exports = DomainFolders;
});
